// extracted by mini-css-extract-plugin
export default {"iconButtonMain":"CustomPopover_iconButtonMain__CobhS","iconButtonActive":"CustomPopover_iconButtonActive__IHdXH","bxShadow":"CustomPopover_bxShadow__kske5"};